import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { BUTTON_SIZES } from 'ui/button';
import { useOrganizationMembersQueryContext } from '../../../contexts/OrganizationMembersQueryContext';
import { MemberOverflowMenu } from '../../Shared/MemberOverflowMenu';
import { MemberRow } from '../types';
import { TableCell } from './styled';

const TableCellPadded = styled(TableCell)`
  padding-right: ${spacing.double};
`;

export const ActionsCell = ({ row }: { row: MemberRow }) => {
  const { membersById } = useOrganizationMembersQueryContext();

  const member = membersById[row.userId];

  return (
    <TableCellPadded>
      <MemberOverflowMenu member={member} size={BUTTON_SIZES.SMALL} />
    </TableCellPadded>
  );
};
